import { USER_SESSION_SERVICE_NAME } from "../../../../services/user-session"
import { TARIFF_SERVICE_NAME, TARIFF_LOCATIONS_SERVICE_NAME } from "../../../../services/tariff"
import { TariffCopySummaryController } from "./tariff-copy-summary.controller"
import { $ROOT_SCOPE_SERVICE_NAME } from "../../../../services/system"

//#region Asset Imports

import './tariff-copy-summary.scss'
import * as TEMPLATE from './tariff-copy-summary.tpl.html'

//#endregion

// #region Consts
export const COMPONENT_NAME: string = 'tariffCopySummary'

// #endregion

export class TariffCopySummaryComponent implements ng.IComponentOptions {
    controller = [
        $ROOT_SCOPE_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        TARIFF_SERVICE_NAME,
        TARIFF_LOCATIONS_SERVICE_NAME,
        TariffCopySummaryController
    ]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE
}